const PaymentDetails = () => {
  return null
}

export default PaymentDetails
